export default {
    state: {
        menuTree: [],  // 导航菜单树
    },
    getters: {
   
    },
    mutations: {
        setMenuTree(state, menuTree){  // 设置导航菜单树
            state.menuTree = menuTree;
        }
    },
    actions: {
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/menu.js